import { storeToRefs } from "pinia"
import { deepCopyObject } from "~~/common/functions"
import { Contractor, Country, DirectionName, OrderForm } from "~~/types/types"
import {useOrderStore} from '~/stores/order';

export default function (props: { direction: DirectionName, isOrderPage: boolean }) {
    const { $showToast } = useNuxtApp()
    const { getOrderPriceAction } = useOrderStore()
    const { orderTotalPrice, orderForm } = storeToRefs(useOrderStore())

    const phones = computed((): string[] => {
        return orderForm.value.customer[props.direction][type.value].phone
    })

    const type = computed((): 'individual' | 'corporation' => {
        return orderForm.value.customer[props.direction].type
    })

    const customer = computed((): OrderForm['customer'] => {
        return deepCopyObject(orderForm.value).customer
    })

    const phone = computed((): string => {
        return orderForm.value.customer[props.direction][type.value].phone[0] || ''
    })

    const email = computed({
        get() {
            return orderForm.value.customer[props.direction][type.value].email
        },
        set(value: string) {
            orderForm.value.customer[props.direction][type.value].email = value
        }
    })

    const countrySelector = computed((): Country => {
        return orderForm.value.customer[props.direction].country
    })

    const isPayer = computed((): boolean => {
        if (props.direction === orderForm.value.customer.payer) {
            return true
        }
        if (orderForm.value.customer.payer !== 'segregated') {
            return false
        }
        return Object.values(orderForm.value.customer.segregated.list)?.includes(props.direction)
    })

    const hasAnotherCurrency = computed((): boolean => {
        return Object.keys(orderTotalPrice.value?.currency?.list || {}).length > 1
    })

    async function onChangeContractor(value: string, contractorList: Contractor): Promise<void> {
        const firstContactFromList = contractorList?.defaultContact?.name ? contractorList.defaultContact : contractorList.contactList?.[0];
        if (type.value === 'corporation') {
            orderForm.value.customer[props.direction][type.value] = {
                companyName: {
                    value: contractorList.name,
                    id: contractorList.guid || ''
                },
                name: firstContactFromList?.name || '',
                phone: [firstContactFromList?.phone || ''],
                email: firstContactFromList?.email || '',

                taxId: contractorList.inn, // inn | taxId
                IEC: contractorList.kpp, // kpp | IEC
                canEditCOD: contractorList.canEditCOD,
                contactList: contractorList.contactList,
                defaultContact: contractorList.defaultContact,
            }

            if (props.isOrderPage) {
                getOrderPriceAction()
            }
        } else {
            orderForm.value.customer[props.direction][type.value].phone = [firstContactFromList?.phone || '']
            orderForm.value.customer[props.direction][type.value].name.value = value
            orderForm.value.customer[props.direction][type.value].name.id = contractorList.guid || ''
            orderForm.value.customer[props.direction][type.value].email = firstContactFromList?.email || ''
            if (isPayer.value && hasAnotherCurrency.value) {
                // Для получения дефолт валюты
                if (props.isOrderPage) {
                    getOrderPriceAction()
                }
            }
        }
        orderForm.value.customer[props.direction].canEditCOD = contractorList.canEditCOD
        //из-за того что телефон получает значение после того как изениться старана а компонент
        // vz-phone-input определяет при вводе код города флаг старны меняется по номеру
        setTimeout(()=> {
            orderForm.value.customer[props.direction].country = (contractorList?.country?.code?.toUpperCase() as Country) ||
                orderForm.value.customer[props.direction].country || 'RU'
        }, 100)
    }

    function showSameContractorToast(name: string) {
        $showToast({
            variant: 'warning',
            title: 'Найдено несколько контрагентов',
            text: `Найдено несколько контрагентов с наименованием ${name}, рекомендуем проверить реквизиты контрагента`,
            autocloseDelay: 8000,
            iconName: 'information-outline'
        })
    }

    return {
        countrySelector,
        phones,
        type,
        customer,
        phone,
        email,
        isPayer,
        hasAnotherCurrency,
        orderForm,
        onChangeContractor,
        showSameContractorToast
    }
}
